module.exports = "/_next/static/images/fk-8833fb78bcbb0203d7a3db53526b2097.svg";